import React, { FC } from 'react';

import cn from 'classnames';

import { LabelTagProps } from './types';

import styles from './styles.module.scss';

/**
 * Компонент лэйбл. Может содержать текст или иконку, или текст и иконку
 * */
export const Label: FC<LabelTagProps> = ({ icon, text, tagClass, iconClass, textClass, color }) => {
	const labelText = text ? (
		<span className={`${styles.LabelText} ${textClass || ''}`}>{text}</span>
	) : null;
	const labelIcon = icon ? (
		<span
			className={`${styles.LabelIcon} ${iconClass || ''}`}
			dangerouslySetInnerHTML={{ __html: icon }}
		/>
	) : null;

	return labelIcon || labelText ? (
		<div className={cn(styles.LabelTag, color && styles[color], tagClass)}>
			{labelIcon}
			{labelText}
		</div>
	) : null;
};
